module.exports = __webpack_public_path__ + "static/tb-2f27ec93ee6a1b351d3b65245afdb664.jpg";